export default __webpack_public_path__ + "static/media/about.45f7f83f.jpg";